



















import Vue from 'vue';
import { getNodesFlattenRecursive } from '@/core/components/tree/treeHelpers';
import { ResourceTypeRelation, ResourceTypeTree, ResourceType } from '@/dto';
import { Component, Prop } from 'vue-property-decorator';
import DataSource from 'devextreme/data/data_source';
import DxTreeView from 'devextreme-vue/tree-view';
import { guid } from '@/core/helpers';

@Component({
    components: {
        DxTreeView
    }
})
export default class InfiniteTreeView extends Vue {
    @Prop({ type: Object, required: true }) public dataSource!: DataSource;
    @Prop({ type: Array, required: true, default: [] }) public resourceTypeRelations!: ResourceTypeRelation[];
    @Prop({ type: Object, required: true, default: null }) public resourceType!: ResourceType | null;
    @Prop({ type: String, required: true }) public keyExpr!: string;
    @Prop({ type: String, required: true, default: [] }) public displayExpr!: string;

    public selectedItems: ResourceTypeTree[] = [];

    public get getAllNodes() {
        return getNodesFlattenRecursive(this.treeInstance.getNodes());
    }

    private itemSelectionChanged(e: any) {
        const selectedItems = e.component.getSelectedNodes().map((item: any) => {
            return item.itemData;
        });
        this.selectedItems = selectedItems;
        this.$emit('selected', selectedItems);
    }

    private async mounted() {
        this.$emit('sendInstance', this.tree);
        this.selectedItems = [];
        const treeDataSource = this.treeInstance.getDataSource();
        if (treeDataSource) {
            treeDataSource.reload();
        }
    }

    private get tree() {
        const element = this.$refs['tree-list'] as unknown;
        return (element as DxTreeView)!;
    }

    private get treeInstance() {
        return this.tree!.instance!;
    }

    private selectItems() {
        const nodes = getNodesFlattenRecursive(this.treeInstance!.getNodes());

        this.resourceTypeRelations.forEach((item: ResourceTypeRelation) => {
            const nodeList = nodes.filter((x: any) => x.alias === item.resourceTypeGroupId);
            nodeList.forEach((node: any) => {
                this.treeInstance!.selectItem(node);
            });
        });
    }
}
